import React from "react";
import { Link } from "react-router-dom";
import fb from "../../Assets/Images/facebook.png";
import insta from "../../Assets/Images/instagram.png";
import linkedin from "../../Assets/Images/linkedin.png";
import youtube from "../../Assets/Images/youtube.png";
import x from "../../Assets/Images/x.png";
import styles from "./SiteFooter.module.css";

const SOCIAL_LINKS = [
  {
    href: "https://www.instagram.com/cookandchef.in/",
    src: insta,
    label: "Instagram",
  },
  {
    href: "https://www.linkedin.com/company/86097906",
    src: linkedin,
    label: "LinkedIn",
  },
  {
    href: "https://www.facebook.com/cookandchef.in/",
    src: fb,
    label: "Facebook",
  },
  {
    href: "https://www.youtube.com/channel/UCRI1TtfWY2P3-88JXQKk2EA",
    src: youtube,
    label: "YouTube",
  },
  {
    href: "https://twitter.com/CookandChef_in",
    src: x,
    label: "X (Twitter)",
  },
];

const FOOTER_LINKS = [
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
  { to: "/faq", label: "FAQs" },
  { to: "/terms-and-conditions", label: "Terms and Conditions" },
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/refund-policy", label: "Refund Policy" },
];

function SiteFooter() {
  return (
    <footer className="main-footer font-small black mt-5">
      <div className={styles.inner}>
        <ul className={styles.socialRow} aria-label="Social media">
          {SOCIAL_LINKS.map(({ href, src, label }) => (
            <li key={href}>
              <a
                href={href}
                className={styles.socialLink}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
              >
                <img
                  src={src}
                  alt=""
                  loading="lazy"
                  width="22"
                  height="22"
                />
              </a>
            </li>
          ))}
        </ul>

        <div className={styles.bottomRow}>
          <p className={styles.copyright}>
            Copyright © 2020-26 By CookandChef India. All Rights Reserved.
          </p>

          <nav className={styles.linkNav} aria-label="Footer">
            <ul className={styles.linkList}>
              {FOOTER_LINKS.map(({ to, label }) => (
                <li key={to}>
                  <Link to={to}>{label}</Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
